// Require the polyfill before requiring any other modules.
// require('intersection-observer');

/**
 * Babel includes a polyfill that includes a custom regenerator runtime and core-js.
 * This will emulate a full ES2015+ environment and is intended to be used in an
 * application rather than a library/tool.
 */

// require('babel-polyfill');

/**
 * Modernizr tests touchevents.
 */

require('browsernizr/test/touchevents');
require('browsernizr/lib/addTest');
require('browsernizr/test/elem/picture');
window.Modernizr = require('browsernizr');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

window.qs = require('qs');
window.axios.defaults.headers.post['Content-Type'] =
    'application/x-www-form-urlencoded';

window.postQs = (params) => {
    params[csrfTokenName] = csrfTokenValue;
    return qs.stringify(params);
};

/**
 * Zenscroll is a vanilla JavaScript library that enables animated
 * vertical scrolling to an element or position within your
 * document or within a scrollable element (DIV, etc.).
 */

window.zenscroll = require('zenscroll');
